/**
 * @flow
 * @relayHash 1518fe926712baf4d06fa34a94498071
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type MaterialRequirementsQueryVariables = {||};
export type MaterialRequirementsQueryResponse = {|
  +materialRequirements: $ReadOnlyArray<{|
    +item: {|
      +id: string,
      +itemNumber: string,
      +name: string,
    |},
    +onHand: number,
    +required: number,
    +shortfall: number,
    +sourceOrders: $ReadOnlyArray<{|
      +id: string,
      +orderNumber: string,
      +requiredAt: ?any,
      +status: OrderStatus,
    |}>,
  |}>
|};
export type MaterialRequirementsQuery = {|
  variables: MaterialRequirementsQueryVariables,
  response: MaterialRequirementsQueryResponse,
|};
*/


/*
query MaterialRequirementsQuery {
  materialRequirements {
    item {
      id
      itemNumber
      name
    }
    onHand
    required
    shortfall
    sourceOrders {
      id
      orderNumber
      requiredAt
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "materialRequirements",
    "storageKey": null,
    "args": null,
    "concreteType": "MaterialRequirement",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "itemNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "onHand",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "required",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "shortfall",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sourceOrders",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "requiredAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MaterialRequirementsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "MaterialRequirementsQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "MaterialRequirementsQuery",
    "id": null,
    "text": "query MaterialRequirementsQuery {\n  materialRequirements {\n    item {\n      id\n      itemNumber\n      name\n    }\n    onHand\n    required\n    shortfall\n    sourceOrders {\n      id\n      orderNumber\n      requiredAt\n      status\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '494e38f9cce664d8d8ccad7820feaaad';
module.exports = node;
